module.exports = __webpack_public_path__ + "static/media/Holyoake_logo.d6245a8e.png";